import { render, staticRenderFns } from "./Tab6Laboratory.vue?vue&type=template&id=5315b719&scoped=true&"
import script from "./Tab6Laboratory.vue?vue&type=script&lang=js&"
export * from "./Tab6Laboratory.vue?vue&type=script&lang=js&"
import style0 from "./Tab6Laboratory.vue?vue&type=style&index=0&id=5315b719&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5315b719",
  null
  
)

export default component.exports